import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('PaymentRequest', PaymentRequestData);

    PaymentRequestData.$inject = ['UtilSvc', 'PaymentEvent'];

    /* @ngInject */
    function PaymentRequestData(UtilSvc, PaymentEvent) {
        PaymentRequest.prototype = {
            build: build,
        };

        function PaymentRequest(paymentRequestData) {
            if (paymentRequestData) {
                this.build(paymentRequestData);
            }
        }

        return PaymentRequest;

        function build(paymentRequestData) {
            this.status = paymentRequestData.status || null;
            this.createdDate = UtilSvc.parseDate(paymentRequestData.createdDate) || null;
            this.updatedDate = UtilSvc.parseDate(paymentRequestData.updatedDate) || null;
            this.paymentRef = paymentRequestData.paymentRef || null;
            this.requestLink = paymentRequestData.requestLink || null;
            this.content = angular.fromJson(paymentRequestData.content) || null;
            this.events =
                _.map(_.orderBy(paymentRequestData.events, 'createdDate', 'desc'), ev => new PaymentEvent(ev)) || null;
        }
    }
})();
